<template>
  <div class="go-top" @click="top"></div>
</template>
<script>
export default {
  name: "goTop",
  data() {
    return {};
  },
  created() {
  },
  methods: {
    top() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style scoped>
.go-top {
  cursor: pointer;
  width: 40px;
  height: 40px;
  background: url("../assets/images/toTop.png") center no-repeat;
  background-size: 40px 40px;
  position: absolute;
  right: -60px;
  bottom: -10px;
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue